import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ArrowRight, Mail, Calendar, Copy, Check } from 'lucide-react';
export function ContactPage() {
  const [formData, setFormData] = useState({
    fullName: '',
    workEmail: '',
    company: '',
    companySize: '',
    industry: '',
    message: ''
  });
  const [copiedEmail, setCopiedEmail] = useState<string | null>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Construct email body with form data
    const emailBody = `
Full Name: ${formData.fullName}
Work Email: ${formData.workEmail}
Company: ${formData.company}
Company Size: ${formData.companySize}
Industry: ${formData.industry}

Message:
${formData.message}
    `.trim();
    // Create mailto link with pre-filled data
    const mailtoLink = `mailto:hello@meetsynthia.ai?subject=Contact Form Submission from ${encodeURIComponent(formData.fullName)}&body=${encodeURIComponent(emailBody)}`;
    // Open email client
    window.location.href = mailtoLink;
    // Optional: Reset form after a delay
    setTimeout(() => {
      setFormData({
        fullName: '',
        workEmail: '',
        company: '',
        companySize: '',
        industry: '',
        message: ''
      });
    }, 1000);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const copyEmail = (email: string) => {
    navigator.clipboard.writeText(email);
    setCopiedEmail(email);
    setTimeout(() => setCopiedEmail(null), 2000);
  };
  return <div className="min-h-screen w-full bg-white selection:bg-[#0066FF] selection:text-white" data-id="element-1979">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-1980">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-1981">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-1982">
            <Link to="/" data-id="element-1983">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-1984" />
            </Link>
            <Navigation data-id="element-1985" />
          </div>
        </div>
      </header>

      <main className="pt-20" data-id="element-1986">
        {/* Hero Section */}
        <section className="relative w-full pt-20 pb-16 px-6 md:px-12 lg:px-24 overflow-hidden bg-white" data-id="element-1987">
          <div className="absolute top-0 right-0 pointer-events-none" style={{
          width: '100%',
          height: '800px'
        }} data-id="element-1988">
            <img src="https://cdn.magicpatterns.com/uploads/kga88EcdPJUPTBaJUremGs/background_thought.png" alt="" className="absolute right-0 top-[2%] w-[100%] h-auto opacity-90" data-id="element-1989" />
          </div>

          <div className="max-w-7xl mx-auto relative z-10" data-id="element-1990">
            <div className="flex flex-col space-y-8" data-id="element-1991">
              <div className="inline-flex items-center px-3 py-1 rounded-full border border-gray-200 bg-gray-50 w-fit" data-id="element-1992">
                <span className="text-xs font-medium text-gray-600 uppercase tracking-wider font-sans" data-id="element-1993">
                  CONTACT US
                </span>
              </div>

              <h1 className="text-5xl md:text-7xl font-bold leading-[0.95] tracking-tight text-black max-w-6xl font-['Syne']" data-id="element-1994">
                Let's Talk.
              </h1>

              <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl font-light" data-id="element-1995">
                We're working with select companies in regulated industries to
                transform workflows with compliant AI. Tell us about your
                challenge.
              </p>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-16 px-6 md:px-12 lg:px-24 bg-white" data-id="element-1996">
          <div className="max-w-7xl mx-auto" data-id="element-1997">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-1998">
              {/* Left Column: Form */}
              <div data-id="element-1999">
                <h2 className="text-2xl font-bold mb-8 font-['Syne']" data-id="element-2000">
                  Get in Touch
                </h2>
                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2001">
                  <div data-id="element-2002">
                    <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2003">
                      Full Name
                    </label>
                    <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2004" />
                  </div>

                  <div data-id="element-2005">
                    <label htmlFor="workEmail" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2006">
                      Work Email
                    </label>
                    <input type="email" id="workEmail" name="workEmail" value={formData.workEmail} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2007" />
                  </div>

                  <div data-id="element-2008">
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2009">
                      Company
                    </label>
                    <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2010" />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2011">
                    <div data-id="element-2012">
                      <label htmlFor="companySize" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2013">
                        Company Size
                      </label>
                      <select id="companySize" name="companySize" value={formData.companySize} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2014">
                        <option value="" data-id="element-2015">Select range</option>
                        <option value="under-500" data-id="element-2016">Under 500</option>
                        <option value="500-3000" data-id="element-2017">500-3,000</option>
                        <option value="3000-10000" data-id="element-2018">3,000-10,000</option>
                        <option value="10000+" data-id="element-2019">10,000+</option>
                      </select>
                    </div>

                    <div data-id="element-2020">
                      <label htmlFor="industry" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2021">
                        Industry
                      </label>
                      <select id="industry" name="industry" value={formData.industry} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2022">
                        <option value="" data-id="element-2023">Select industry</option>
                        <option value="financial" data-id="element-2024">Financial Services</option>
                        <option value="healthcare" data-id="element-2025">
                          Healthcare/Life Sciences
                        </option>
                        <option value="legal" data-id="element-2026">Legal</option>
                        <option value="insurance" data-id="element-2027">Insurance</option>
                        <option value="pharma" data-id="element-2028">Pharma</option>
                        <option value="other" data-id="element-2029">Other</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-2030">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2031">
                      What brings you to Synthia?
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={4} placeholder="Tell us about your workflow challenge, current AI initiatives, or what you're looking to accomplish..." className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2032" />
                  </div>

                  <button type="submit" className="w-full group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-[#0066FF] font-['Syne'] hover:bg-black hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black" data-id="element-2033">
                    <span data-id="element-2034">SEND MESSAGE</span>
                    <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-2035" />
                  </button>
                </form>
              </div>

              {/* Right Column: Contact Info */}
              <div className="lg:pt-0" data-id="element-2036">
                <div className="bg-[#F8F8F8] p-8 md:p-12 rounded-lg border border-gray-100 sticky top-32" data-id="element-2037">
                  <h2 className="text-2xl font-bold mb-8 font-['Syne']" data-id="element-2038">
                    Schedule a demo or reach us ASAP
                  </h2>

                  <div className="space-y-8" data-id="element-2039">
                    <div data-id="element-2040">
                      <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-2041">
                        Email us here
                      </p>
                      <div className="flex items-center gap-2" data-id="element-2042">
                        <a href="mailto:hello@meetsynthia.ai" className="text-xl font-medium hover:text-[#0066FF] transition-colors flex items-center gap-2 cursor-pointer" data-id="element-2043">
                          <Mail className="w-5 h-5" data-id="element-2044" />
                          hello@meetsynthia.ai
                        </a>
                        <button onClick={() => copyEmail('hello@meetsynthia.ai')} className="p-2 hover:bg-gray-200 rounded transition-colors" title="Copy email address" data-id="element-2045">
                          {copiedEmail === 'hello@meetsynthia.ai' ? <Check className="w-4 h-4 text-green-600" data-id="element-2046" /> : <Copy className="w-4 h-4 text-gray-500" data-id="element-2047" />}
                        </button>
                      </div>
                    </div>

                    <div data-id="element-2048">
                      <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-2049">
                        Talk to Sales
                      </p>
                      <div className="flex items-center gap-2" data-id="element-2050">
                        <a href="mailto:sales@meetsynthia.ai" className="text-xl font-medium hover:text-[#0066FF] transition-colors flex items-center gap-2 cursor-pointer" data-id="element-2051">
                          <Mail className="w-5 h-5" data-id="element-2052" />
                          sales@meetsynthia.ai
                        </a>
                        <button onClick={() => copyEmail('sales@meetsynthia.ai')} className="p-2 hover:bg-gray-200 rounded transition-colors" title="Copy email address" data-id="element-2053">
                          {copiedEmail === 'sales@meetsynthia.ai' ? <Check className="w-4 h-4 text-green-600" data-id="element-2054" /> : <Copy className="w-4 h-4 text-gray-500" data-id="element-2055" />}
                        </button>
                      </div>
                    </div>

                    <div className="pt-8 border-t border-gray-200" data-id="element-2056">
                      <a href="https://calendly.com/demo-meetsynthia" target="_blank" rel="noopener noreferrer" className="w-full group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-black transition-all duration-200 bg-white border-2 border-black font-['Syne'] hover:bg-black hover:text-white hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black" data-id="element-2057">
                        <Calendar className="mr-2 w-5 h-5" data-id="element-2058" />
                        <span data-id="element-2059">SCHEDULE A DEMO</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-2060" />
    </div>;
}